import React from "react";
import styles from "./styles/ChannelPartnerCTA.module.css";
import Icon from "../Home/common/Icon";
import ctaBg from "../../../images/contact-cta.jpg";

export default function ChannelPartnerCTA() {
  return (
    <section className={styles.cta} style={{ backgroundImage: `url(${ctaBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <p className={styles.text}>
          Alliance Automation is here to provide you with more information, answer any questions
          you may have and create an effective solution for your factory automation requirements.
        </p>
        <a href="/contact" className={styles.ctaBtn}>
          <span className={styles.ctaIcon} aria-hidden="true">
            <Icon.Phone />
          </span>
          <span>CONTACT US</span>
        </a>
        <div className={styles.divider} aria-hidden="true" />
      </div>
    </section>
  );
}
